<template>
<div id="home">
 <section id="top">
  <div class="inner-header">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <ul class="main-navigation">
            <LoginLogout v-if="!isMobile" background="'black'"></LoginLogout>
          </ul>
        </div>
      </div>
    </div>
  </div>
   <div class="inner">
     <div class="containerbox">
       <div class="logo logo-homepage">
         <router-link to="/">
         <a href="#"><img src="../assets/logo-homepage.png"></a>
         </router-link>
       </div>
       <h3 v-if="isMobile" class="black">Not yet available on mobile.</h3>
       <h3 v-else class="black">
         <p><i>Analyze</i> text classes: e.g. What are the stylistic differences between Jeremiah and Ezekiel?</p>
         <p><i>Categorize</i> a test text: e.g. Is Lamentations closer in style to Jeremiah or Ezekiel?</p>
         <div class="home_links">
         <a href="/static/help/Content/Tiberias/about.htm" target="_blank" class="f blue link">About Tiberias</a>
         <span>&nbsp;</span><span>&nbsp;</span>
         <a href="https://www.youtube.com/watch?v=yUx7VD6YHpw&feature=youtu.be" target="_blank" class="f blue link"><i class="blue fas fa-video fa-xs"></i><span>&nbsp;</span>Overview of Tiberias</a>
         </div>
       </h3>
       <button v-if="!isMobile" type="button" @click="goToExperiment"  class="button lg hoverable bg-blue btn-custom"><div class="anim"></div>Start Experiment</button>
     </div>
   </div>
 </section>

  <section v-if="!isMobile" id="bottom">
    <div class="container">
      <a style="display: none" href="#" data-toggle="modal" data-target="#about" class="link-use blue">How to use</a>
      <how-popup></how-popup>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <div class="col-lg-2 hidden-md"></div>
          <div class="col-lg-8 col-md-12 col-sm-12">
            <div class="row img-frame">
              <div class="col-xs-12 col-sm-3">
                <img style="width: 54px; height: 58px;" src="../assets/Lowercase-Outline.png">
                <p>You choose the texts that make up each of the classes you’re defining</p>
              </div>
              <div class="col-xs-12 col-sm-3">
                <img style="width: 57px; height: 57px;" src="../assets/Service-Outline.png">
                <p> Tiberias determines the lexical, morphological and syntactic markers of each class, which you can refine</p>
              </div>
              <div class="col-xs-12 col-sm-3">
                <img style="width: 58px; height: 58px;" src="../assets/Microscope-Outline.png">
                <p>You choose the text you<br> want to classify</p>
              </div>
              <div class="col-xs-12 col-sm-3">
                <img style="width: 54px; height: 58px;" src="../assets/Idea-Solid.png">
                <p>Tiberias classifies your text and displays the stylistic features that determined the classification</p>
              </div>
            </div>
          </div>
          <div class="col-lg-2 hidden-md"></div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>
<script>
import HowPopup from './howPopup'
import LoginLogout from './LoginLogout'
import {StateChanges} from '../store/stateChanges'
import AppFooter from './appFooter.vue'

export default {
  components: {LoginLogout, HowPopup, AppFooter},
  name: 'Home',
  data () {
    const isMobile =
      (navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i))
    return {
      isMobile
    }
  },
  methods: {
    goToExperiment () {
      this.$store.commit(StateChanges.RESET_EXPERIMENT)
      this.$router.push({path: 'experiment'})
    },
    changeBodyClass () {
      document.body.className = 'home'
    }
  },
  mounted: function () {
    // document.getElementsByClassName('footer')[0].style.setProperty('display', 'none')
    this.changeBodyClass()
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue